import { QcPlanDetailOption } from '../../../contracts/qc-plan/qc-plan-detail.model';

export interface IQcPlanDetailOptionState {
    qcPlanDetailOption: QcPlanDetailOption;
}

const initialState: IQcPlanDetailOptionState = {
    qcPlanDetailOption: {
        'section1': true, // QC Plan
        'section2': false, // Usage Detail
        'section3': true, // QC Performance
        'section4': true, // QC Parameter
        'section5': true, // Risk Calculation
        'section6': true, // Harm Input
        'section7': false, // Data Range
        'section8': true // Unity Central Data
    }
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/qc-plan/IQcPlanDetailOptionState.ts